export default "__VITE_PUBLIC_ASSET__7894221a__"